module.exports = __webpack_public_path__ + "static/media/apps_we_use.6d6f6380.svg";